import {Component, NgZone, Input, Output, EventEmitter} from "@angular/core";
import "rxjs/add/operator/map";
import "rxjs/add/operator/subscribeOn";
import {ComponentBase} from "../base/ComponentBase";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {CompletionState} from "../services/usermodel/usermodel.objects";
import {ILibrarySelection} from "./library.objects";
import {ClientConfiguration} from "../services/configuration/client.config";
import {RaVersion} from "../services/configuration/ra.version";
import {BookSessionType, ErrorType} from "../constants";

@Component({
               selector: "current-selection-component",
               templateUrl: "./current.selection.component.html",
               styleUrls: ["./current.selection.component.scss"]
           })
export class CurrentSelectionComponent extends ComponentBase {

    @Input()
    public selection:ILibrarySelection = null;

    @Input()
    public nextSelection:ILibrarySelection;

    @Output()
    public selectRequest:EventEmitter<ILibrarySelection> = new EventEmitter<ILibrarySelection>();

    constructor (
        private config:ClientConfiguration,
        private loggingService:BugsnagLoggingService
    ) {
        super("CurrentSelectionComponent");
    }

    public getLibraryImage(imgSrc:string):string {
        return this.config.libraryImageUrl(imgSrc);
    }

    public selectionClick():void {
        this.selectRequest.emit(this.selection);
    }

    public nextSelectionClick():void {
        this.selectRequest.emit(this.nextSelection);
    }

    public getSelectionLabel():string {
        if (this.selection.isCurrent) {
            return "current-selection-words";
        } else if (this.nextSelection) {
            return "next-selection-words";
        }
    }

    public getSelectionPanelWidth():string {
        return "col-xl-8 col-lg-10 col-md-10 col-sm-10 row";

    }

    public getClassForStep(step:number):string {
        switch (step) {
            case 1 :
                if (this.selection.taqCompleteState === CompletionState.COMPLETED) {
                    return "step1-complete";
                }  else if (this.selection.currentStep === BookSessionType.PREVIEW) {
                    return "step1-current";
                } else if (this.selection.taqCompleteState === CompletionState.INCOMPLETE) {
                    return "step1-current";
                } else {
                    return "step1";
                }
            case 2 :
                if (this.selection.recordingCompleteState === CompletionState.COMPLETED) {
                    return "step2-complete";
                } else if (this.selection.currentStep === BookSessionType.FLUENCY) {
                    return "step2-current";
                } else if (this.selection.recordingCompleteState === CompletionState.INCOMPLETE) {
                    return "step2-current";
                } else {
                    return "step2";
                }
            case 3 :
                if (this.selection.quizCompleteState === CompletionState.COMPLETED) {
                    return "step3-complete";
                } else if (this.selection.currentStep === BookSessionType.QUIZ) {
                    return "step3-current";
                } else if (this.selection.quizCompleteState === CompletionState.INCOMPLETE) {
                    return "step3-current";
                } else {
                    return "step3";
                }
            default:
                this.loggingService.error("unknown step: " + step.toString(), ErrorType.USER_STATE);
                return "";
        }
    }
}
